import { render, staticRenderFns } from "./ClaimsBucket.2.vue?vue&type=template&id=6c68e4a8&"
import script from "./ClaimsBucket.2.vue?vue&type=script&lang=js&"
export * from "./ClaimsBucket.2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports